<template>
<div class="chapter">
<div class="inner_page">
<p class="p1"><span class="t1">Copyright</span></p>
<p class="p1"><span class="t2">Published by</span></p>
<p class="p1"><span class="t2">Dreamspinner Press</span></p>
<p class="p1"><span class="t2">382 NE 191st Street #88329</span></p>
<p class="p1"><span class="t2">Miami, FL 33179-3899, USA</span></p>
<p class="p2"><a href="http://www.dreamspinnerpress.com/" target="_blank"><span class="t3">http://www.dreamspinnerpress.com/</span></a></p>
<p class="p2"><span class="t2">This is a work of fiction. Names, characters, places, and incidents either are the product of the author’s imagination or are used fictitiously, and any resemblance to actual persons, living or dead, business establishments, events, or locales is entirely coincidental.</span></p>
<p class="p2"><span class="t2">Beneath the Palisade: Reliance</span><span class="t2"><br/></span><span class="t2">Copyright © 2012 by Joel Skelton</span></p>
<p class="p2"><span class="t2">Cover Art by Catt Ford</span></p>
<p class="p2"><span class="t2">All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system without the written permission of the Publisher, except where permitted by law. To request permission and all other inquiries, contact Dreamspinner Press, 382 NE 191st Street #88329, Miami, FL 33179-3899, USA</span><span class="t2"><br/></span><a href="http://www.dreamspinnerpress.com/" target="_blank"><span class="t3">http://www.dreamspinnerpress.com/</span></a></p>
<p class="p2"><span class="t2">ISBN: 978-1-61372-403-3</span></p>
<p class="p2"><span class="t2">Printed in the United States of America</span><span class="t2"><br/></span><span class="t2">First Edition</span><span class="t2"><br/></span><span class="t2">March 2012</span></p>
<p class="p1"><span class="t2">eBook edition available</span></p>
<p class="p1"><span class="t2">eBook ISBN: 978-1-61372-404-0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?304bc347